import React from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import 'components/commandpanel/Layers/LayerView.scss';
function RMLayersTabs({
  headingTab1,
  headingTab2,
  contentTab1,
  contentTab2,
  selectedTabIndex,
  setSelectedTab,
}) {
  const gridLayerTab = {
    width: '50%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.25rem',
    lineHeight: '1.45rem',
  };

  return (
    <Tabs
      id="rmlayertabs-tabs-wrapper"
      data-testid="rmlayertabs-tabs-wrapper"
      style={{ height: '82.178%' }}
      selectedIndex={selectedTabIndex}
      onSelect={(tabIndex) => setSelectedTab(tabIndex)}
    >
      <TabList
        id="rmlayertabs-list"
        data-testid="rmlayertabs-list"
        style={{ display: 'flex', height: '7.488%', margin: 0 }}
      >
        <Tab
          id={`rmlayertabs-header-heading-${headingTab1}`}
          data-testid={`rmlayertabs-header-heading-${headingTab1}`}
          style={gridLayerTab}
        >
          {headingTab1}
        </Tab>
        <Tab
          id={`rmlayertabs-header-heading-${headingTab2}`}
          data-testid={`rmlayertabs-header-heading-${headingTab2}`}
          style={gridLayerTab}
        >
          {headingTab2}
        </Tab>
      </TabList>
      <div
        id="rmlayerstabs-tab-content"
        data-testid="rmlayerstabs-tab-content"
        className=" overflow-auto"
        style={{ padding: '2.91% 3.1% 0px 3.1%', height: '92.512%' }}
      >
        <TabPanel
          id="rmlayerstabs-tabpanel-content1"
          data-testid="rmlayerstabs-tabpanel-content1"
          style={{ height: '100%' }}
        >
          {contentTab1}
        </TabPanel>
        <TabPanel
          id="rmlayerstabs-tabpanel-content2"
          data-testid="rmlayerstabs-tabpanel-content2"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          {contentTab2}
        </TabPanel>
      </div>
    </Tabs>
  );
}

export default RMLayersTabs;
